import React, { Component } from 'react';
import './videostage.css';

class Videostage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            videoList: []        
        }; 
      }
    
    componentDidMount() {
        this.getCurrentVid();
      }

    componentDidUpdate(){
       if(this.state.videoList.length > 0){
            const url = window.location.href;
            var currentID = url.split('/')[4];
            if (currentID == null ){
                    currentID = 11
            }
            if(parseInt(currentID,10) !== this.state.videoList[0].id){
                this.getCurrentVid();
            }
        }
    

      }
    
      // Retrieves the list of items from the Express app
      getCurrentVid = () => {
        const url = window.location.href;
        var currentID = url.split('/')[4];
        if(currentID == null){
            currentID = 11
        };

        fetch('/api/revideo?'+currentID)
        .then(res => res.json())
        .then(videoList => this.setState({videoList}));

      }

    render() {
        const { videoList } = this.state;
        
        return (
            <React.Fragment>
                {videoList.length ? (
                    <div className="videoHolder fullStage">
                        {videoList.map((item, i) => {
                        return(
                            <React.Fragment key={item.id}>
                                <div className="videoPlayer fullWidth relative marginBotSmall">
                                <div className="loadingSample fullWidth fullHeight whiteT centerT"><p className="blinkFast whiteT upperT boldT titleFont">Loading Video</p></div>
                                    <span dangerouslySetInnerHTML={{ __html : item.itemURL}}></span></div>
            
                                <p className="resourceTitle centerT"><span dangerouslySetInnerHTML={{ __html : item.itemTitle }}></span>
                                </p>

                                
                            </React.Fragment>
                        );
                        })}
                    </div>
                    ) : (
                        <div className="fullWidth fullHeight redT blinkFast centeredContent loader">
                        <h1>•</h1>
                    </div>
                    
                    )
                }
            </React.Fragment>
        )
    }
  }
  
  export default Videostage;




// WEBPACK FOOTER //
// ./src/components/videostage/videostage.js